import './PropertyTourQuestions.scss'

import _ from 'lodash'
import React, { Component } from 'react'
import cx from 'classnames'
import {
  AGENT_STATUS_MET,
  AGENT_STATUS_SPOKE,
  PROPERTY_TOUR_SCHEDULE_STATUS,
} from 'common/constants'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { DateTimePicker } from 'manager/views/components/ReferralStatus/DateTimePicker'
import {
  selectIsInterestedInTour,
  selectIsRequestedTourCompleted,
  selectIsRequestedTourScheduled,
  selectIsRequestedTourScheduledBeforeToday,
  selectIsTourCompleted,
  selectIsTourRescheduled,
  selectRequestedTourScheduledDate,
  selectRequestedTourScheduledTime,
  selectRescheduledTourDate,
  selectRescheduledTourTime,
  selectTourCompletedOpIds,
} from 'manager/selectors/referral_status_selectors'
import {
  selectFormattedPropertyInquiryTourDateTime,
  selectPropertyInquiryLocation,
  selectPropertyInquiryRequestedTourStatus,
  selectReferralName,
  selectPropertyInquiryToursWithNeededUpdates,
} from 'manager/selectors/referral_selectors'
import {
  setSelectedStatus,
  setIsInterestedInTour,
  setIsRequestedTourCompleted,
  setIsRequestedTourScheduled,
  setIsTourCompleted,
  setIsTourRescheduled,
  setRequestedTourScheduledDate,
  setRequestedTourScheduledTime,
  setRescheduledTourDate,
  setRescheduledTourTime,
  toggleTourCompleteOpIds,
} from 'manager/redux/referral_status'
import { show as showModal } from 'redux-modal'
import { withRouter } from 'react-router'
import OpCheckbox from 'common/views/components/OpCheckbox'

export const YesNoButton = ({ selected, onClick, children }) => {
  const className = cx("PropertyTourQuestions__button", {
    selected
  })

  return (
    <button className={className} onClick={onClick}>
      {children}
    </button>
  )
}

export const ScheduleTourQuestion = ({ formattedTourDateTime, isRequestedTourScheduled, tourLocation, onClick }) => {
  const { address, city, state, zip } = tourLocation

  return (
    <div>
      <div className="PropertyTourQuestions__question">Did you schedule time to tour this property?</div>
      <div className="PropertyTourQuestions__data">
        <div className="PropertyTourQuestions__data--address">
          <i className='fa fa-map-marker PropertyTourQuestions__icon'/>
          <div>{`${address}\n${city}, ${state} ${zip}`}</div>
        </div>
        <div className="PropertyTourQuestions__data--datetime">
          <i className='fa fa-calendar PropertyTourQuestions__icon'/>
          <div>{`Consumer Availability:\n${formattedTourDateTime}`}</div>
        </div>
      </div>
      <div className="PropertyTourQuestions__buttons">
        <YesNoButton
          selected={ isRequestedTourScheduled === true }
          onClick={ () => onClick(true) }>
          Yes
        </YesNoButton>
        <YesNoButton
          selected={ isRequestedTourScheduled === false }
          onClick={ () => onClick(false) }>
          No
        </YesNoButton>
      </div>
    </div>
  )
}

export const InterestedTourQuestion = ({ isInterestedInTour, name, onClick }) => {
  return (
    <div>
      <div className="PropertyTourQuestions__question">{`Is ${name} still interested in this property?`}</div>
      <div className="PropertyTourQuestions__buttons">
        <YesNoButton
          selected={ isInterestedInTour === true }
          onClick={ () => onClick(true) }>
          Yes
        </YesNoButton>
        <YesNoButton
          selected={ isInterestedInTour === false }
          onClick={ () => onClick(false) }>
          No
        </YesNoButton>
      </div>
    </div>
  )
}

export const CompleteRequestedTourQuestion = ({ isRequestedTourCompleted, onClick }) => {
  return (
    <div>
      <div className="PropertyTourQuestions__question">Did you complete this property tour?</div>
      <div className="PropertyTourQuestions__buttons">
        <YesNoButton
          selected={ isRequestedTourCompleted === true }
          onClick={ () => onClick(true) }>
          Yes
        </YesNoButton>
        <YesNoButton
          selected={ isRequestedTourCompleted === false }
          onClick={ () => onClick(false) }>
          No
        </YesNoButton>
      </div>
    </div>
  )
}

export const CompleteScheduledTourQuestion = ({
  formattedTourDateTime,
  isTourCompleted,
  tourLocation,
  onClick,
  toursToConfirm,
  selectedTourOpIds,
  onToggleTourOpId,
}) => {
  const { address, city, state, zip } = tourLocation

  return (
    <div>
      <div className="PropertyTourQuestions__question">Did you complete the scheduled property tour?</div>
      <div className="PropertyTourQuestions__data">
        <div className="PropertyTourQuestions__data--address">
          <i className='fa fa-map-marker PropertyTourQuestions__icon'/>
          <div>{`${address}\n${city}, ${state} ${zip}`}</div>
        </div>
        <div className="PropertyTourQuestions__data--datetime">
          <i className='fa fa-calendar PropertyTourQuestions__icon'/>
          <div>{`${formattedTourDateTime}`}</div>
        </div>
      </div>
      <div className="PropertyTourQuestions__buttons">
        <YesNoButton
          selected={ isTourCompleted === true }
          onClick={ () => onClick(true) }>
          Yes
        </YesNoButton>
        <YesNoButton
          selected={ isTourCompleted === false }
          onClick={ () => onClick(false) }>
          No
        </YesNoButton>
      </div>
      { isTourCompleted &&
        <AdditionalTourChecklist toursToConfirm={toursToConfirm.slice(1)} selectedOpIds={selectedTourOpIds} onToggleOpId={onToggleTourOpId} />
      }
    </div>
  )
}

export const RescheduleTourQuestion = ({ isTourRescheduled, onClick }) => {
  return (
    <div>
      <div className="PropertyTourQuestions__question">Did you reschedule this property tour?</div>
      <div className="PropertyTourQuestions__buttons">
        <YesNoButton
          selected={ isTourRescheduled === true }
          onClick={ () => onClick(true) }>
          Yes
        </YesNoButton>
        <YesNoButton
          selected={ isTourRescheduled === false }
          onClick={ () => onClick(false) }>
          No
        </YesNoButton>
      </div>
    </div>
  )
}

export const AdditionalTourChecklist = ({ toursToConfirm, selectedOpIds, onToggleOpId }) => {
  if (!toursToConfirm || !toursToConfirm.length) {
    return <div className="PropertyTourQuestions__statement">Great! Let us know how it went.</div>
  } else {
    return (
      <div>
        <div className="PropertyTourQuestions__question">Did you tour any other properties at this time?</div>
        {toursToConfirm.map(({ tour_op_id, property = {} }) => (
          <button key={tour_op_id} className="PropertyTourQuestions__tour_checkbox" onClick={() => onToggleOpId(tour_op_id)}>
            <OpCheckbox
              label={`${property.street_address}, ${property.city}, ${property.state} ${property.zip}`}
              checked={selectedOpIds.includes(tour_op_id)}
            />
          </button>
        ))}
      </div>
    )
  }
}

export const RequestedStatusQuestions = ({
  completeRequestedTour,
  formattedTourDateTime,
  isInterestedInTour,
  isRequestedTourCompleted,
  isRequestedTourScheduled,
  isRequestedTourScheduledBeforeToday,
  referralName,
  requestedTourScheduledDate,
  requestedTourScheduledTime,
  setIsInterestedInTour,
  setIsRequestedTourScheduled,
  setRequestedTourScheduledDate,
  setRequestedTourScheduledTime,
  tourLocation,
  toursToConfirm,
  selectedTourOpIds,
  onToggleTourOpId,
}) => {
  return (
    <div>
      <ScheduleTourQuestion
        formattedTourDateTime={formattedTourDateTime}
        isRequestedTourScheduled={isRequestedTourScheduled}
        tourLocation={tourLocation}
        onClick={setIsRequestedTourScheduled}
      />
      { isRequestedTourScheduled === true && (
        <div>
          <DateTimePicker
            dateFormat="MMMM D"
            datePlaceholder="Select new date..."
            dateValue={requestedTourScheduledDate}
            label="Select new date and time..."
            onDateChange={setRequestedTourScheduledDate}
            onTimeChange={setRequestedTourScheduledTime}
            timeFormat="h:mm A"
            timePlaceholder="Select new time..."
            timeValue={requestedTourScheduledTime}
            useNative
          />
          { isRequestedTourScheduledBeforeToday && (
            <div>
              <CompleteRequestedTourQuestion
                isRequestedTourCompleted={isRequestedTourCompleted}
                onClick={completeRequestedTour}
              />
              { isRequestedTourCompleted === true &&
                <AdditionalTourChecklist toursToConfirm={toursToConfirm.slice(1)} selectedOpIds={selectedTourOpIds} onToggleOpId={onToggleTourOpId} />
              }
              { isRequestedTourCompleted === false &&
                <InterestedTourQuestion
                  isInterestedInTour={isInterestedInTour}
                  name={referralName}
                  onClick={setIsInterestedInTour}
                />
              }
            </div>
          )}
        </div>
      )}
      { isRequestedTourScheduled === false &&
        <InterestedTourQuestion
          isInterestedInTour={isInterestedInTour}
          name={referralName}
          onClick={setIsInterestedInTour}
        />
      }
    </div>
  )
}

export const ScheduledStatusQuestions = ({
  completeScheduledTour,
  formattedTourDateTime,
  isTourCompleted,
  isTourRescheduled,
  rescheduledTourDate,
  rescheduledTourTime,
  setIsTourRescheduled,
  setRescheduledTourDate,
  setRescheduledTourTime,
  tourLocation,
  toursToConfirm,
  selectedTourOpIds,
  onToggleTourOpId,
}) => {
  return (
    <div>
      <CompleteScheduledTourQuestion
        formattedTourDateTime={formattedTourDateTime}
        isTourCompleted={isTourCompleted}
        tourLocation={tourLocation}
        onClick={completeScheduledTour}
        toursToConfirm={toursToConfirm}
        selectedTourOpIds={selectedTourOpIds}
        onToggleTourOpId={onToggleTourOpId}
      />
      { isTourCompleted === false && (
        <div>
          <RescheduleTourQuestion
            isTourCompleted={isTourCompleted}
            isTourRescheduled={isTourRescheduled}
            onClick={setIsTourRescheduled}
          />
          { isTourRescheduled === true &&
            <DateTimePicker
              dateFormat="MMMM D"
              datePlaceholder="Select new date..."
              dateValue={rescheduledTourDate}
              label="Select new date and time..."
              onDateChange={setRescheduledTourDate}
              onTimeChange={setRescheduledTourTime}
              timeFormat="h:mm A"
              timePlaceholder="Select new time..."
              timeValue={rescheduledTourTime}
              useNative
            />
          }
        </div>
      )}
    </div>
  )
}

export class PropertyTourQuestions extends Component {

  updateStatus = () => {
    const { location, setSelectedStatus, showModal } = this.props

    const selectedStatus = location.query.editstatus
    if (selectedStatus == AGENT_STATUS_SPOKE) {
      showModal('StatusChangedModal', { onConfirm: () => setSelectedStatus(AGENT_STATUS_MET) })
    }
  }

  completeRequestedTour = isCompleted => {
    const { setIsRequestedTourCompleted, toggleTourCompleteOpIds, toursToConfirm } = this.props

    setIsRequestedTourCompleted(isCompleted)
    toggleTourCompleteOpIds(_.get(toursToConfirm, ['0', 'tour_op_id']))

    if (isCompleted) {
      this.updateStatus()
    }
  }

  completeScheduledTour = isCompleted => {
    const { setIsTourCompleted, toggleTourCompleteOpIds, toursToConfirm } = this.props

    setIsTourCompleted(isCompleted)
    toggleTourCompleteOpIds(_.get(toursToConfirm, ['0', 'tour_op_id']))

    if (isCompleted) {
      this.updateStatus()
    }
  }

  render() {
    const {
      formattedTourDateTime,
      isInterestedInTour,
      isRequestedTourCompleted,
      isRequestedTourScheduled,
      isRequestedTourScheduledBeforeToday,
      isTourCompleted,
      isTourRescheduled,
      referralName,
      requestedTourScheduledDate,
      requestedTourScheduledTime,
      rescheduledTourDate,
      rescheduledTourTime,
      setIsInterestedInTour,
      setIsRequestedTourScheduled,
      setIsTourRescheduled,
      setRequestedTourScheduledDate,
      setRequestedTourScheduledTime,
      setRescheduledTourDate,
      setRescheduledTourTime,
      tourLocation,
      tourStatus,
      toursToConfirm,
      tourCompletedOpIds,
      toggleTourCompleteOpIds,
    } = this.props

    const isTourStatusRequested = tourStatus === PROPERTY_TOUR_SCHEDULE_STATUS.REQUESTED
    const isTourStatusScheduled = tourStatus === PROPERTY_TOUR_SCHEDULE_STATUS.SCHEDULED
    const isTourStatusSuggested = tourStatus === PROPERTY_TOUR_SCHEDULE_STATUS.SUGGESTED

    return (
      <div className="PropertyTourQuestions">
        { (isTourStatusRequested || isTourStatusSuggested) &&
          <RequestedStatusQuestions
            completeRequestedTour={this.completeRequestedTour}
            formattedTourDateTime={formattedTourDateTime}
            isInterestedInTour={isInterestedInTour}
            isRequestedTourCompleted={isRequestedTourCompleted}
            isRequestedTourScheduled={isRequestedTourScheduled}
            isRequestedTourScheduledBeforeToday={isRequestedTourScheduledBeforeToday}
            referralName={referralName}
            requestedTourScheduledDate={requestedTourScheduledDate}
            requestedTourScheduledTime={requestedTourScheduledTime}
            setIsInterestedInTour={setIsInterestedInTour}
            setIsRequestedTourScheduled={setIsRequestedTourScheduled}
            setRequestedTourScheduledDate={setRequestedTourScheduledDate}
            setRequestedTourScheduledTime={setRequestedTourScheduledTime}
            tourLocation={tourLocation}
            toursToConfirm={toursToConfirm}
            selectedTourOpIds={tourCompletedOpIds}
            onToggleTourOpId={toggleTourCompleteOpIds}
          />
        }
        { isTourStatusScheduled &&
          <ScheduledStatusQuestions
            completeScheduledTour={this.completeScheduledTour}
            formattedTourDateTime={formattedTourDateTime}
            isTourCompleted={isTourCompleted}
            isTourRescheduled={isTourRescheduled}
            rescheduledTourDate={rescheduledTourDate}
            rescheduledTourTime={rescheduledTourTime}
            setIsTourRescheduled={setIsTourRescheduled}
            setRescheduledTourDate={setRescheduledTourDate}
            setRescheduledTourTime={setRescheduledTourTime}
            tourLocation={tourLocation}
            toursToConFirm={toursToConfirm}
            toursToConfirm={toursToConfirm}
            selectedTourOpIds={tourCompletedOpIds}
            onToggleTourOpId={toggleTourCompleteOpIds}
          />
        }
      </div>
    )
  }
}

const selector = createStructuredSelector({
  formattedTourDateTime: selectFormattedPropertyInquiryTourDateTime,
  isInterestedInTour: selectIsInterestedInTour,
  isRequestedTourCompleted: selectIsRequestedTourCompleted,
  isRequestedTourScheduled: selectIsRequestedTourScheduled,
  isRequestedTourScheduledBeforeToday: selectIsRequestedTourScheduledBeforeToday,
  isTourCompleted: selectIsTourCompleted,
  isTourRescheduled: selectIsTourRescheduled,
  referralName: selectReferralName,
  requestedTourScheduledDate: selectRequestedTourScheduledDate,
  requestedTourScheduledTime: selectRequestedTourScheduledTime,
  rescheduledTourDate: selectRescheduledTourDate,
  rescheduledTourTime: selectRescheduledTourTime,
  tourLocation: selectPropertyInquiryLocation,
  tourStatus: selectPropertyInquiryRequestedTourStatus,
  toursToConfirm: selectPropertyInquiryToursWithNeededUpdates,
  tourCompletedOpIds: selectTourCompletedOpIds,
})

const actions = {
  setIsInterestedInTour,
  setIsRequestedTourCompleted,
  setIsRequestedTourScheduled,
  setIsTourCompleted,
  setIsTourRescheduled,
  setSelectedStatus,
  setRequestedTourScheduledDate,
  setRequestedTourScheduledTime,
  setRescheduledTourDate,
  setRescheduledTourTime,
  showModal,
  toggleTourCompleteOpIds,
}

export default connect(selector, actions)(withRouter(PropertyTourQuestions))
